import { createSelector } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import companyToken from "Utils/companyToken";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

export const toastMultipleCompanies = createApi({
  reducerPath: "toastMultipleCompanies",
  baseQuery: fetchBaseQuery({
    baseUrl: "/toast/router",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),
  endpoints: (builder) => ({
    getToastCompanies: builder.query({
      query: () => {
        return appendAuthParams(`/toast-multiple-companies${location.search}`);
      },
    }),
  }),
});

export const { useGetToastCompaniesQuery } = toastMultipleCompanies;
